import { useContext } from 'react'

import type { ImageProps } from '~/components/atoms/Image/Image'
import ReportSignupIntro from '~/components/report/components/ReportSignupIntro/ReportSignupIntro'
import { ReportTheme } from '~/components/report/types'
import { GlobalStoreContext } from '~/contexts/GlobalStoreContext'
import { GlobalStoreProps } from '~/contexts/GlobalStoreReducer'

import useMabPostHog, {
  PushInteractionLocation,
  PushInteractionType,
  PushWebProduct,
} from './useMabPostHog'

const useReportSignUp = () => {
  const { stateDispatch } = useContext(GlobalStoreContext)
  const { pushEvent } = useMabPostHog()

  const openReportSignUp = (image?: ImageProps) => {
    stateDispatch({
      type: GlobalStoreProps.UPDATE_MODAL_STATE,
      payload: {
        isOpen: true,
        component: ReportSignupIntro,
        props: {
          theme: ReportTheme.secondary, // Dark theme (secondary)
          image,
        },
        isDrawer: true, // Open as drawer (slideout panel)
      },
    })

    pushEvent('Report sign up opened', {
      interactionLocation: PushInteractionLocation.Reports,
      interactionType: PushInteractionType.Click,
      webProduct: PushWebProduct.Reports,
    })
  }

  return {
    openReportSignUp,
  }
}

export default useReportSignUp
